import { upsertLayerMetadata } from '@app/domains/layers/services/layers.service'
import { pendingMetadataPatchesAtom } from '@app/domains/layers/state/layers.atoms'
import type { UpsertLayerMetadataBody } from '@app/types/layerTypes'
import { useMutation } from '@tanstack/react-query'
import { useSetAtom } from 'jotai'

export const useUpsertLayerMetadata = () => {
  const applyMetadataPatch = useSetAtom(pendingMetadataPatchesAtom)

  return useMutation({
    mutationFn: ({ layerId, body }: { layerId: string; body: UpsertLayerMetadataBody }) =>
      upsertLayerMetadata(layerId, body),
    onSuccess: (savedMetadata, { layerId }) => {
      applyMetadataPatch((currentPatches) => ({
        ...currentPatches,
        [layerId]: savedMetadata,
      }))
    },
  })
}
